import { api } from '../lib/api';

export type Range = [number, number];
export interface Word {
  s: number;
  e: number;
  w: string;
}

/** GET /v1/videos/:id/edit */
export interface EditState {
  videoId: string;
  shareId: string;
  title: string;
  kind: 'screen' | 'audio';
  status: string;
  sourceUrl: string;
  sourceDurationSec: number;
  keep: Range[] | null;
  version: number;
  words: Word[] | null;
  transcriptStatus: 'pending' | 'ready' | 'failed' | null;
}

export function fetchEditState(videoId: string): Promise<EditState> {
  return api<EditState>(`/v1/videos/${videoId}/edit`);
}

export function applyEdit(
  videoId: string,
  body: { keep: Range[] | null; words?: Word[] },
): Promise<{ ok: boolean; rendering: boolean; version: number }> {
  return api(`/v1/videos/${videoId}/edit`, { method: 'PUT', body });
}
